<template>
  <div class="login-box">
    <div class="login-logo">
      <router-link to="/"><b>Mister</b> Aladin</router-link>
    </div>
    <!-- /.login-logo -->
    <div class="login-box-body">
      <p class="login-box-msg">Sign in to start your session</p>
      <form @submit.prevent="login">

        <div v-if="errorMessage" class="alert alert-danger">
          <a class="close" @click="errorMessage = false">&times;</a>
          {{ errorMessage }}
        </div>

        <div class="form-group has-feedback">
          <input type="text" class="form-control" placeholder="Email" v-model="credentials.email">
          <span class="glyphicon glyphicon-user form-control-feedback"></span>
        </div>
        <div class="form-group has-feedback">
          <input type="password" class="form-control" placeholder="Password" v-model="credentials.password">
          <span class="glyphicon glyphicon-lock form-control-feedback"></span>
        </div>
        <div class="row">
          <div class="col-xs-8">
            <router-link to="/forgot">Forgot password</router-link>
          </div>
          <!-- /.col -->
          <div class="col-xs-4">
            <button type="submit" class="btn btn-primary btn-block btn-flat">Sign In</button>
          </div>
          <!-- /.col -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import qs from 'qs';

  export default {
    name: 'Login',
    data() {
      return {
        credentials: {
          email: null,
          password: null,
        },
        errorMessage: null,
      };
    },
    methods: {
      login() {
        this.axios.post('/auth/login', qs.stringify(this.credentials)).then(async (response) => {
          const token = response.data.token;
          const claims = this.parseJwt(token);

          this.$store.commit('SET_TOKEN', token);
          this.$store.commit('SET_USER', claims);

          // Save to local storage as well
          if (window.localStorage) {
            window.localStorage.setItem('token', token);
          }
          this.$router.push('/dashboard');
        }).catch((error) => {
          if (error.response) {
            this.errorMessage = error.response.data.errors;
          }
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Login.vue